<template>
    <div id="accordion">
        <DxAccordion :data-source="accordionData" item-title-template="itemTitle">
            <template #itemTitle="{ data }">
                <div class="header" :class="{ 'roluri-header': data.title === 'Roluri' }">
                    <b>{{ data.title }}</b>
                </div>
            </template>
            <template #item="{ data }">
                <DxDataGrid v-if="data.title === 'Roluri'" :data-source="dsRoluri" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedRoluri" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxFilterRow :visible="true" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxColumn data-field="Nume" :allowEditing="false"/>
                    <DxColumn data-field="Explicatie" :allowEditing="false" />
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />


                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Agenti'" :data-source="dsAgenti" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedAgenti" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxFilterRow :visible="true" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxColumn data-field="UserID" :visible="false" />
                    <DxColumn data-field="Nume" :allowEditing="false"/>
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Categorii Comenzi'" :data-source="dsCategoriiComenzi"
                    key-expr="ID" :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedCategoriiComenzi" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="Nume" :allowEditing="false" :allow-filtering="true" />
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Tipuri de Documente'" :data-source="dsTipuri" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedDocumente" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="UserID" :visible="false" />
                    <DxColumn data-field="Cod" :visible="false" :allowEditing="false" :allow-filtering="true" />
                    <DxColumn data-field="CategorieID" caption="Categorie" :allowEditing="false" :allow-filtering="true">
                        <DxLookup :data-source="dsCategorii" value-expr="Id" display-expr="Nume"></DxLookup>
                    </DxColumn>
                    <DxColumn data-field="Nume" :allowEditing="false" :allow-filtering="true" />

                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Gestiuni'" :data-source="dsGestiuni" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedGestiuni" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="ID" :visible="false" />
                    <DxColumn data-field="Cod" :allowEditing="false" :allow-filtering="true"/>
                    <DxColumn data-field="Nume" :allowEditing="false" :allow-filtering="true"/>
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Meniuri'" :data-source="dsMeniuri" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedMeniuri" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="Nume" :allowEditing="false" :allow-filtering="true" />
                    <DxColumn data-field="Explicatie" :allowEditing="false" :allow-filtering="true"/>
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Drepturi Custom'" :data-source="dsMeniuriCustom" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedMeniuriCustom" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="Nume" :allowEditing="false" :allow-filtering="true" />
                    <DxColumn data-field="Explicatie" :allowEditing="false" :allow-filtering="true"/>
                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Categorii Produse'" :data-source="dsCategoriiProduse"
                    key-expr="ID" :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedCategoriiProduse" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="ClasaID" :allowEditing="false" :allow-filtering="true" caption="Clasa">
                        <DxLookup :data-source="dsClase" value-expr="ID" display-expr="Nume" />
                    </DxColumn>
                    <DxColumn data-field="Nume" :allowEditing="false" :allow-filtering="true" />

                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Capitole'" :data-source="dsCapitole" key-expr="ID"
                    :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedCapitole" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="Nume"  :allowEditing="false" :allow-filtering="true" />

                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

                <DxDataGrid v-if="data.title === 'Categorii Documente'" :data-source="dsCategoriiDocumente"
                    key-expr="ID" :allowColumnReordering="true" :allowColumnResizing="true" :columnAutoWidth="false"
                    :columnMinWidth="50" :columnResizingMode="'nextColumn'" :show-borders="true"
                    :filter-sync-enabled="true" :show-row-lines="true" :show-column-lines="false" class="border"
                    :on-row-updated="onRowUpdatedCategoriiDocumente" :on-editor-preparing="onEditor" ref="dataGridRef">
                    <DxEditing mode="cell" :allow-updating="true" />
                    <DxPaging :page-size="10" :page-index="1" />
                    <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
                    <DxFilterRow :visible="true" />
                    <DxColumn data-field="Nume" :allowEditing="false" :allow-filtering="true" />

                    <DxColumn data-field="HasRight" data-type="boolean" caption="Are drept?" :allowEditing="true"
                        :allow-filtering="false" />
                    <DxColumn data-field="Citeste" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Modifica" data-type="boolean" :allowEditing="true" :allow-filtering="false" />
                    <DxColumn data-field="Sterge" data-type="boolean" :allowEditing="true" :allow-filtering="false" />

                </DxDataGrid>

            </template>
        </DxAccordion>

    </div>

    <DxPopupAdd :visible.sync="isModalVisible" />

</template>
<script lang="ts">
import { defineComponent, ref } from 'vue';
import { DxButton } from 'devextreme-vue/button';
import DxPopupAdd, { DxToolbarItem } from 'devextreme-vue/popup';
import DxAccordion from 'devextreme-vue/accordion';
import DxTagBox from 'devextreme-vue/tag-box';
import DxCheckBox from 'devextreme-vue/check-box';
import DxSlider, { DxTooltip, DxLabel } from 'devextreme-vue/slider';
import {
    DxColumn,
    DxDataGrid,
    DxFilterRow,
    DxLoadPanel,
    DxPaging,
    DxSelection,
    DxSorting,
    DxStateStoring,
    DxToolbar,
    DxEditing,
    DxLookup
} from 'devextreme-vue/data-grid';
import 'devextreme/dist/css/dx.light.css';
import 'devextreme/dist/css/dx.common.css';
import notify from 'devextreme/ui/notify';
import AUTH_DrepturiUtilizatori from '@/services/AUTH/AUTH_DrepturiUtilizatori';
import ODataStore from 'devextreme/data/odata/store';
import AppSetting from '@/settings/appSettings';
export default defineComponent({
    components: {
        DxToolbar,
        DxDataGrid,
        DxColumn,
        DxSorting,
        DxSelection,
        DxFilterRow,
        DxStateStoring,
        DxLoadPanel,
        DxPaging,
        DxButton,
        DxLabel,
        DxPopupAdd,
        DxToolbarItem,
        DxAccordion,
        DxTagBox,
        DxCheckBox,
        DxSlider,
        DxTooltip,
        DxEditing,
        DxLookup
    },

    data() {
        return {
            accordionData: [
                { title: "Roluri" },
                { title: "Agenti" },
                { title: "Capitole" },
                { title: "Categorii Comenzi" },
                { title: "Categorii Documente" },
                { title: "Categorii Produse" },
                { title: "Gestiuni" },
                { title: "Tipuri de Documente" },
                { title: "Meniuri" },
                { title: "Drepturi Custom" },


            ],
            dsClase: {} as ODataStore,
            dsRoluri: [] as any[],
            dsCategorii: {} as ODataStore,
            dsGestiuni: [] as any[],
            dsAgenti: [] as any[],
            dsTipuri: [] as any[],
            dsMeniuri: [] as any[],
            dsCapitole: [] as any[],
            dsMeniuriCustom: [] as any[],
            dsCategoriiComenzi: [] as any[],
            dsCategoriiProduse: [] as any[],
            dsCategoriiDocumente: [] as any[],
            isModalVisible: false,
            dataGridRef: ref<DxDataGrid | null>(null),
        };
    },
    props: {
        userId: { type: [Number, String, null], default: null },
    },
    computed: {
        normalizedUserId(): string | null {
            if (this.userId === null || this.userId === undefined) return null;
            return String(this.userId);
        },
    },
    watch: {
        normalizedUserId: {
            immediate: true,
            handler(id) {
                this.getAgenti(id);
                this.getTipuri(id);
                this.getGestiuni(id);
                this.getMeniuri(id);
                this.getRoluri(id);
                this.getCategoriiComenzi(id);
                this.getMeniuriCustom(id);
                this.getCategoriiProduse(id);
                this.getCapitole(id);
                this.getCategoriiDocumente(id);
            },
        },
    },
    methods: {
        createODataContext() {
            this.dsCategorii = new ODataStore({
                url: AppSetting.API_Url_DocumenteOdata + 'DOC_Categorii',
                key: 'ID',
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                    };
                },
            }
            )
            this.dsClase = new ODataStore({
                url: AppSetting.API_Url + 'PRO_Clase',
                key: 'ID',
                version: 4,
                beforeSend: (e) => {
                    e.headers = {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + localStorage.getItem('ERA_Jwt'),
                    };
                },
            }
            )
        },
        onAddClick() {
            this.isModalVisible = true;
        },
        onEditor(e) {
            if (['Citeste', 'Modifica', 'Sterge'].includes(e.dataField)) {
                const hasRight = e.row?.data?.HasRight === true;
                e.editorOptions = e.editorOptions || {};
                e.editorOptions.disabled = !hasRight;
                if (!hasRight && e.value === true) {
                    e.setValue(false);
                }
            }
        },
        onRowUpdatedAgenti(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const userId = this.normalizedUserId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!userId || !agentId) {
                console.warn('Lipsesc userId/agentId', { userId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    userId,
                    agentId,
                    tip: 'COM_Agenti',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiUtilizatori.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiUtilizatori.updateDrepturi(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiUtilizatori.delete(userId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedRoluri(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;

            const userId = this.normalizedUserId;
            const rolId = row.ID;
            const rightId = row.RightId ?? null;
            const hasRight = row.HasRight === true;

            if (!userId || !rolId) {
                console.warn('Lipsesc userId/rolId', { userId, rolId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    userId,
                    rolId,
                };


                AUTH_DrepturiUtilizatori.saveRol(body).
                    then((response) => {
                        notify('Rol adaugat cu succes!', 'success', 1000);
                        const newId = response?.data?.rightId ?? response?.data?.ID;
                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(rolId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })

            }

            if (!hasRight && !rightId) {
                AUTH_DrepturiUtilizatori.deleteRoluriUtilizatori(userId, rolId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(rolId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedDocumente(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const userId = this.normalizedUserId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!userId || !agentId) {
                console.warn('Lipsesc userId/agentId', { userId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    userId,
                    agentId,
                    tip: 'DOC_Tipuri',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiUtilizatori.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiUtilizatori.updateDrepturi(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiUtilizatori.delete(userId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedGestiuni(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const userId = this.normalizedUserId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!userId || !agentId) {
                console.warn('Lipsesc userId/agentId', { userId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    userId,
                    agentId,
                    tip: 'GES_Gestiuni',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiUtilizatori.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiUtilizatori.updateDrepturi(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiUtilizatori.delete(userId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedMeniuri(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const userId = this.normalizedUserId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!userId || !agentId) {
                console.warn('Lipsesc userId/agentId', { userId, agentId });
                return;
            }


            if (hasRight && !rightId) {
                const body = {
                    userId,
                    agentId,
                    tip: 'Meniu',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiUtilizatori.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiUtilizatori.updateDrepturi(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiUtilizatori.delete(userId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedMeniuriCustom(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const userId = this.normalizedUserId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!userId || !agentId) {
                console.warn('Lipsesc userId/agentId', { userId, agentId });
                return;
            }


            if (hasRight && !rightId) {
                const body = {
                    userId,
                    agentId,
                    tip: 'Custom',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiUtilizatori.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiUtilizatori.updateDrepturi(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiUtilizatori.delete(userId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedCategoriiComenzi(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const userId = this.normalizedUserId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!userId || !agentId) {
                console.warn('Lipsesc userId/agentId', { userId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    userId,
                    agentId,
                    tip: 'PRO_CategoriiComenzi',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiUtilizatori.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiUtilizatori.updateDrepturi(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiUtilizatori.delete(userId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedCategoriiProduse(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const userId = this.normalizedUserId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!userId || !agentId) {
                console.warn('Lipsesc userId/agentId', { userId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    userId,
                    agentId,
                    tip: 'PRO_Categorii',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiUtilizatori.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiUtilizatori.updateDrepturi(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiUtilizatori.delete(userId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedCapitole(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const userId = this.normalizedUserId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!userId || !agentId) {
                console.warn('Lipsesc userId/agentId', { userId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    userId,
                    agentId,
                    tip: 'DOC_Capitole',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiUtilizatori.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiUtilizatori.updateDrepturi(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiUtilizatori.delete(userId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        onRowUpdatedCategoriiDocumente(e) {
            const row = e.oldData ? { ...e.oldData, ...e.data } : e.data;
            const userId = this.normalizedUserId;
            const agentId = row.ID;
            const hasRight = row.HasRight === true;
            const rightId = row.RightId ?? null;

            const citeste = row.Citeste === true;
            const modifica = row.Modifica === true;
            const sterge = row.Sterge === true;

            if (!userId || !agentId) {
                console.warn('Lipsesc userId/agentId', { userId, agentId });
                return;
            }

            if (hasRight && !rightId) {
                const body = {
                    userId,
                    agentId,
                    tip: 'DOC_Categorii',
                    citeste,
                    modifica,
                    sterge
                };
                AUTH_DrepturiUtilizatori.save(body)
                    .then((response) => {
                        notify('Drept adăugat cu succes!', 'success', 1000);

                        const newId = response?.data?.rightId
                            ?? response?.data?.ID;

                        if (newId) {
                            row.RightId = newId;
                            const idx = this.$refs.dataGridRef.instance.getRowIndexByKey(agentId);
                            if (idx >= 0) {
                                this.$refs.dataGridRef.instance.cellValue(idx, 'RightId', newId);
                            }
                        }
                    })
            }

            if (hasRight && rightId) {
                AUTH_DrepturiUtilizatori.updateDrepturi(rightId, {
                    Citeste: citeste,
                    Modifica: modifica,
                    Sterge: sterge
                })
                    .then(() => {
                        notify('Drept actualizat!', 'success', 1000);
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la actualizare!', 'error', 1000);
                    });
                return;
            }


            if (!hasRight && rightId) {
                AUTH_DrepturiUtilizatori.delete(userId, agentId, rightId)
                    .then(() => {
                        notify('Drept șters cu succes!', 'success', 1000);
                        row.RightId = null;
                    })
                    .catch((error) => {
                        console.error(error);
                        notify('Eroare la ștergere!', 'error', 1000);
                        this.$refs.dataGridRef.instance.cellValue(e.component.getRowIndexByKey(agentId), 'HasRight', true);
                    });
                return;
            }

        },
        getAgenti(userId: string) {
            if (!userId) return;
            AUTH_DrepturiUtilizatori.getAgenti(encodeURIComponent(userId))
                .then(r => this.dsAgenti = r.data ?? [])
                .catch(console.error);
        },
        getTipuri(entityId: string) {
            if (!entityId) return;
            AUTH_DrepturiUtilizatori.getTipuri(encodeURIComponent(entityId))
                .then(r => this.dsTipuri = r.data ?? [])
                .catch(console.error);
        },
        getGestiuni(entityId: string) {
            if (!entityId) return;
            AUTH_DrepturiUtilizatori.getGestiuni(encodeURIComponent(entityId))
                .then(r => this.dsGestiuni = r.data ?? [])
                .catch(console.error);
        },
        getMeniuri(entityId) {
            if (!entityId) return;
            AUTH_DrepturiUtilizatori.getMeniuri(encodeURIComponent(entityId))
                .then(r => this.dsMeniuri = r.data.filter((item: any) => item.Meniu === true || item.Meniu === 1))

                .catch((e: Error) => {
                    console.log(e)
                });
        },
        getMeniuriCustom(entityId) {
            if (!entityId) return;
            AUTH_DrepturiUtilizatori.getMeniuriCustom(encodeURIComponent(entityId))
                .then(r => this.dsMeniuriCustom = r.data.filter((item: any) => item.Meniu === false || item.Meniu === 0))

                .catch((e: Error) => {
                    console.log(e)
                });
        },
        getRoluri(userId: string) {
            if (!userId) return;
            AUTH_DrepturiUtilizatori.getRoluri(encodeURIComponent(userId))
                .then(r => this.dsRoluri = r.data ?? [])
                .catch(console.error);
        },
        getCategoriiComenzi(userId: string) {
            if (!userId) return;
            AUTH_DrepturiUtilizatori.getCategoriiComenzi(encodeURIComponent(userId))
                .then(r => this.dsCategoriiComenzi = r.data ?? [])
                .catch(console.error);
        },
        getCategoriiProduse(userId: string) {
            if (!userId) return;
            AUTH_DrepturiUtilizatori.getCategoriiProduse(encodeURIComponent(userId))
                .then(r => this.dsCategoriiProduse = r.data ?? [])
                .catch(console.error);
        },
        getCategoriiDocumente(userId: string) {
            if (!userId) return;
            AUTH_DrepturiUtilizatori.getCategoriiDocumente(encodeURIComponent(userId))
                .then(r => this.dsCategoriiDocumente = r.data ?? [])
                .catch(console.error);
        },
        getCapitole(userId: string) {
            if (!userId) return;
            AUTH_DrepturiUtilizatori.getCapitole(encodeURIComponent(userId))
                .then(r => this.dsCapitole = r.data ?? [])
                .catch(console.error);
        },
        onClick() {
            this.isModalVisible = true;
        },
        onRefreshClick() {
            this.createODataContext();
            this.getAgenti();
            this.getTipuri();
            this.getGestiuni();
            this.getMeniuri();
            this.getCategoriiProduse();
            this.getCategoriiDocumente();
            notify('Datele au fost actualizate cu succes!', 'success', 1000)
        },
        onCancelEdit() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onSaveEdit() {
            this.dataGridRef?.instance?.saveEditData();
        },
    },
    mounted() {
        this.createODataContext();
        this.getAgenti();
        this.getTipuri();
        this.getGestiuni();
        this.getMeniuri();
        this.getCapitole();
        //this.getMeniuriCustom();
        this.getRoluri();
        this.getCategoriiComenzi();
        this.getCategoriiProduse();
        this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
    },
});
</script>
<style scoped>
.roluri-header {
    background-color: #f44336 !important;
    color: white !important;
    padding: 6px 12px;
    border-radius: 0px;
}

.roluri-header.dx-state-hover {
    background-color: #f44336 !important;
}
</style>
